import React from 'react';
import { EmailUpdateAlertView } from 'partial/EmailUpdateAlert/EmailUpdateAlertView';
import { useEmailUpdateAlert } from './hooks/EmailUpdateAlert.hook';
import { useViewModule } from 'hook/helper.hook';

const EmailUpdateAlertController = props => {
  const emailUpdateAlertState = useEmailUpdateAlert();
  useViewModule({ 'Page Position': 'Turn On Email Resurrected' });

  if (emailUpdateAlertState.showAlert) {
    return <EmailUpdateAlertView {...emailUpdateAlertState} />;
  } else {
    return '';
  }
};

export default EmailUpdateAlertController;
